import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { useFormState } from 'react-final-form';
import useDateFnsLocale from 'src/common/hooks/useDateFnsLocale';
import { formatDateRange } from 'src/common/utils/dateHelpers';
import { TripCartFormState } from 'src/listing/types';
import TripCartPanelContent from 'src/trip-cart-deprecated/components/panel/TripCartPanelContent';
import TripCartCalendar from 'src/trip-cart-deprecated/components/TripCartCalendar';
import TripCartContentFooter from 'src/trip-cart-deprecated/components/TripCartContentFooter';
import { useTripCartContext } from 'src/trip-cart-deprecated/hooks/useTripCartContext';
import Button from 'src/common/components/ButtonDS22';
import TripCartCaptainAndMultiday from 'src/trip-cart-deprecated/components/TripCartCaptainAndMultiDay';
import styles from './TripCartPanelCalendar.module.scss';

const TripCartPanelCalendar: FC = () => {
  const [t] = useTranslation('listing-page');
  const { values: { formSelectedDates } } = useFormState<TripCartFormState>();
  const { closePanel } = useTripCartContext();
  const [startDate, endDate] = formSelectedDates;
  const dateLocale = useDateFnsLocale();
  const dateRange = formatDateRange(
    startDate,
    endDate,
    dateLocale,
  ) ?? t('trip-cart--drawer-title--date-duration');

  return (
    <TripCartPanelContent title={dateRange}>
      <div className={styles.root}>
        <TripCartCaptainAndMultiday />
        <TripCartCalendar />
      </div>
      <TripCartContentFooter>
        <Button
          variant="secondary"
          onClick={() => closePanel()}
        >
          {t('trip-cart--action-done')}
        </Button>
      </TripCartContentFooter>
    </TripCartPanelContent>
  );
};

export default TripCartPanelCalendar;
